import { AppUser } from "../../lib/auth";
import { createContext } from "react";

export type AuthContextValues = {
  currentUser: AppUser | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextValues | null>(null);
AuthContext.displayName = "AuthContext";
